const SIGN_IN_EMAIL_KEY = 'emailForSignIn';
const INTRO_DIALOG_DISMISSED = "introDialogDismissed";
const TRUE = 'TRUE';

export default class LocalStorageService {
    public static setDidUserDismissIntroDialog() {
        window.localStorage.setItem(INTRO_DIALOG_DISMISSED, TRUE);
    }

    public static getDidUserDismissIntroDialog(): boolean {
        return window.localStorage.getItem(INTRO_DIALOG_DISMISSED) === TRUE;
    }

    public static setSignInEmail(email: string) {
        window.localStorage.setItem(SIGN_IN_EMAIL_KEY, email);
    }

    public static getSignInEmail() {
        return window.localStorage.getItem(SIGN_IN_EMAIL_KEY);
    }

    public static removeSignInEmail() {
        window.localStorage.removeItem(SIGN_IN_EMAIL_KEY);
    }
}


// WEBPACK FOOTER //
// ./src/services/LocalStorage/LocalStorageService.ts